import React from "react";
import GPAP_Button from "../../../../gpap-lib/Button_Collection";
import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';

const ButtonGridItem = (props) => {
    return(
        <Grid item xs={12}>
            <GPAP_Button
                style={{width: "400px"}}
                href={props.link}  startIcon={<SearchIcon />}>
                {props.label}
            </GPAP_Button>
        </Grid>
    );
}

export default ButtonGridItem;